module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ace767df9a3f8b309d6f873c01afb4e4.gif";